import React from "react";
import styled from "styled-components";

const FlipContainer = styled.div`
    width: 224px;
    height: 336px;
    perspective: 1100px;

    @media all and (max-width: 479px) {
        width: 30vw;
        height: 40vw;
    }

    &:hover .Card {
        transform: rotateY(180deg);
    }
`;

const Card = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    transform-style: preserve-3d;
    transition: 0.4s;
`;

const CardFace = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    backface-visibility: hidden;
`;

const Front = styled(CardFace)`
    border: 10px solid #004076;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media all and (max-width: 479px) {
        border: 1vw solid #004076;
    }
`;

const Back = styled(CardFace)`
    background-image: url("${process.env.PUBLIC_URL}/media/cardback.png");
    background-size: cover;
    background-position: center;
    transform: rotateY(180deg);
`;

const ImageContainer = styled.div`
    width: 208px;
    height: 256px;
    background-image: url(${(props) => props.imageUrl});
    background-size: cover;
    background-position: center;

    @media all and (max-width: 479px) {
        width: 28vw;
        height: 36vw;
    }
`;

const NameContainer = styled.div`
    width: 100%;
    height: 81px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    background-color: #004076;

    @media all and (max-width: 479px) {
        height: 12vw;
        font-size: 1em;
    }
`;

const PokeCard = ({ image, name }) => {
    return (
            <FlipContainer>
                <Card className="Card">
                    <Front>
                        <ImageContainer imageUrl={image} />
                        <NameContainer>{name}</NameContainer>
                    </Front>
                    <Back />
                </Card>
            </FlipContainer>
    );
};

export default PokeCard;